import { GroupType, OptionalAssets, Program } from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export default class ProductService extends CrudService {
  static override route = 'product';

  async getProgramsAndGroupsByAsset(asset: OptionalAssets) {
    try {
      const response = await this.httpService.get<
        BaseResponse<{ groups: GroupType[]; programs: Program[] }>
      >(`${this.path}/asset/${asset}`);
      return response.data;
    } catch (error) {
      console.error(`Failed getting products by asset`, error);
      throw error;
    }
  }
}
